import type { ValidationErrors } from "final-form";
import type { JSX } from "react";
import { Form } from "react-final-form";
import styled from "styled-components";
import t from "../../shared/translations";
import { Textarea } from "../task/stylings";

export interface IFormValues {
    answer: string;
}

export const defaultValues: IFormValues = {
    answer: "",
};

interface IProps {
    labels: {
        answer: string;
    };
    errors: {
        answer: string;
    };
    initialValues: IFormValues;
    onSubmit: (values: IFormValues) => Promise<void>;
}

const Center = styled.div`
    text-align: center;
`;

function validate(values: IFormValues, errMsg: { answer: string }): ValidationErrors {
    const errors: ValidationErrors = {};
    if (!values.answer) {
        errors.answer = errMsg.answer;
    }
    return errors;
}

function TaskForm({ initialValues, onSubmit, labels, errors }: IProps): JSX.Element {
    return (
        <Form onSubmit={onSubmit} validate={(values) => validate(values, errors)} initialValues={initialValues}>
            {({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit}>
                    <Textarea name="answer" placeholder={labels.answer} />
                    <Center>
                        <button type="submit" disabled={submitting}>
                            {t("player.custom-task.form-submit")}
                        </button>
                    </Center>
                </form>
            )}
        </Form>
    );
}

export default TaskForm;
